import Service from "./service"
import { ActionContext } from "vuex"
const store = "routeItems"

// Metodo get não entra na regra de sincronização
const getRouteItemById = async (
  { dispatch }: ActionContext<any, any>,
  id: number
) => {
  const response = await Service().getRouteItem(id)
  dispatch("addRouteItem", response.data)
  Promise.resolve()
}

const saveRouteItems = ({ commit }: any, obj: object) => {
  commit("SAVE_ROUTE_ITEMS", obj)
}

const addRouteItem = ({ commit }: any, obj: any) => {
  commit("add_route_item", obj)
}

const updateRouteItem = async (
  { commit }: ActionContext<any, any>,
  data: any
) => {
  const mutations = "UPDATE_ROUTE_ITEM"

  return Service()
    .patch({
      ...data,
      vuex: {
        store,
        name: "Atualização de ordem de serviço",
        type: "update",
        action: "updateRouteItem",
        dispatch: false,
        mutations,
      },
    })
    .then((result: any) => {
      commit(mutations, result.data)
    })
}

const startRouteItem = async (
  { commit }: ActionContext<any, any>,
  routeItem: object
) => {
  // Possui um by pass em momento Offline
  const mutations = "UPDATE_ROUTE_ITEM"
  return Service()
    .start(
      {
        store,
        name: "Iniciando ordem de serviço",
        action: "startRouteItem",
        type: "update",
        dispatch: false,
        mutations,
      },
      routeItem
    )
    .then((result: any) => {
      commit(mutations, result.data)
    })
}

const accessRouteItem = async (_: any, id: number) => {
  // Possui um by pass em momento Offline
  return Service().access(id)
}

const getJobs = async ({ commit }: any) => {
  return Service()
    .jobs()
    .then(async result => {
      await commit("SAVE_JOBS", result.data)
    })
}

const getReasonForNotSingning = async ({ commit }: ActionContext<any, any>) => {
  const { data } = await Service().getReasonForNotSigning()

  commit("save_reason_for_not_signing", data)
}

const getAbnormalities = async ({ commit }: any) => {
  return Service()
    .abnormalities()
    .then(async result => {
      console.log(result)
      await commit("SAVE_ABNORMALITIES", result.data)
    })
}

const getServiceTypes = async ({ commit }: any) => {
  return Service()
    .serviceTypes()
    .then(async result => {
      await commit("SAVE_SERVICE_TYPES", result.data)
    })
}

const getProviders = async ({ commit }: ActionContext<any, any>) => {
  return Service()
    .providers()
    .then((result: any) => {
      commit("SAVE_PROVIDERS", result.data)
    })
}

const createRouteItem = async (
  { dispatch }: ActionContext<any, any>,
  data: any
) => {
  return Service()
    .create({
      vuex: {
        store,
        name: "Criação de ordem de serviço",
        action: "addRouteItem",
        type: "create",
        dispatch: true,
      },
      data,
    })
    .then((result: any) => {
      dispatch("addRouteItem", result.data)
    })
}
export default {
  getRouteItemById,
  updateRouteItem,
  saveRouteItems,
  getServiceTypes,
  startRouteItem,
  accessRouteItem,
  getJobs,
  createRouteItem,
  getAbnormalities,
  getProviders,
  getReasonForNotSingning,
  addRouteItem,
}
